const Day = {
    "name": "Day Name",
    "status": "Status",
    "description": "Description",
    "search": "Search",
    "day": "Day",
    "error_name": "Enter Day Name",
    "error_status": "Select Status",
    "table_name": "DAY NAME",
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",
}
export default Day;
